import { render, staticRenderFns } from "./TooFewPhotoBookPicturesWarnDialog.vue?vue&type=template&id=2499404a&"
import script from "./TooFewPhotoBookPicturesWarnDialog.vue?vue&type=script&lang=js&"
export * from "./TooFewPhotoBookPicturesWarnDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports